import { ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import Avatar from '../Avatar';
import { useState } from 'react';

const AutocompleteOption = ({ props, option, file = false }: any) => {
    const { id, name, imgUrl, email, fallbackImage = null } = option || {};
    const [imgSrc, setImgSrc] = useState(imgUrl);
    return (
        <ListItem {...props} key={id}>
            <ListItemAvatar>
                <Avatar name={name} url={imgSrc} file={file} avatarProps={{ onError: () => setImgSrc(fallbackImage) }} />
            </ListItemAvatar>
            <ListItemText
                primary={name}
                secondary={email}
                primaryTypographyProps={{ variant: 'body1' }}
                secondaryTypographyProps={{ variant: 'body2' }}
            />
        </ListItem>
    );
};

export default AutocompleteOption;
